<template>
  <div v-show="!noRecords">
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul v-show='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <label>غرض الاتصال:</label>
          <input disabled value='طلب صيانة' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <label>حالة الاتصال:</label>
          <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
            <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <label>الاجراء:</label>
          <select class="form-control" style="padding: 0px" v-model="record.call_action_id">
            <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <tbDate :mytitle='DateTitle' :today='today' v-model= 'date' ></tbDate>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <label>ملاحظات الاتصال:</label>
          <input  @keyup='mirrorNotes()' class="form-control" v-model="record.callNotes" name='notes' type='text'>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <label>ملاحظات الفنى:</label>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
      </div>
      <div class='col-lg-9 col-sm-9' style='padding: 10px 0px 0px 10px;'>
        <label>الصيانة المطلوبة:</label>
        <input v-model='record.maintenance_request' class='form-control' name='amount' type='text'>
      </div>
      <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
        <label>مصاريف الصيانة:</label>
        <input  @keypress="isNumber($event)" v-model='record.maintenance_expenses' class='form-control' name='amount' type='text'>
      </div>
      <div v-if='!successShow' class='col-lg-12 col-sm-12' style='text-align:center;padding:10px'>
        <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
        <button  @click='saveData()'  style="width: 100px" type='button' class='btn btn-success'>إصدار</button>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #00E40E;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'CreateDailyReceipts',
  data () {
    return {
      actions: {},
      callStatus: {},
      today: true,
      receiptDate: '',
      title: '',
      DateTitle: 'التاريخ',
      validationErrors: '',
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      branches: {},
      type: 0,
      uid: '',
      dateTo: '',
      date: '',
      noRecords: false,
      isInLimit: false
    }
  },
  methods: {
    tabSelected (id) {
      this.record = null
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.GetCallData()
      this.uid = id
      this.getData(id)
    },
    // ========================================================
    GetCallData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-customer-call-logs', {
        token: localStorage.getItem('token'),
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingData = false
          this.actions = res.data.Actions
          this.callStatus = res.data.Status
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ========================================================
    mirrorNotes () {
      this.record.notes = this.record.callNotes
    },
    // ========================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ========================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // ========================================================
    getData (id) {
      this.isContractOffersLoading = true
      this.noRecords = false
      axios.post(this.$apiURL + 'get-customer-data-receipt04', {
        token: localStorage.getItem('token'),
        id: id,
        branch_id: this.$store.state.customerData.branche_id
      })
        .then(res => {
          if (res.data === 'No Records') {
            this.noRecords = true
          } else {
            this.isContractOffersLoading = false
            this.record = res.data
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    // ========================================================
    saveData () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'create-cash-receipt04', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        amount: this.record.paid,
        amount_str: this.record.amount_str,
        maintenance_expenses: this.record.maintenance_expenses,
        caption: '............................................................................................ وذلك عن تنفيذ صيانة',
        date: this.date,
        delay: this.record.delay,
        rest: this.record.rest,
        rest_str: '.................................................................................................. و المبلغ المتبقى',
        maintenance_request: this.record.maintenance_request,
        maintenance_required: this.record.maintenance_required,
        notes: this.record.notes,
        call_status_id: this.record.call_status_id,
        call_action_id: this.record.call_action_id,
        call_type_id: 3,
        callNotes: this.record.callNotes,
        call_delay: this.record.call_delay
      })
        .then(res => {
          this.isLoadingSave = false
          this.record.id = res.data.RecId
          this.errorShow = false
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateDailyReceipts04.vue